<template>
  <div>
    <page-header
      :actions="pageHeaderActionsConfig"
      left-side-class="col-xl-4 pb-2"
      :page="headerConfig"
      right-side-class="col-xl-8 align-items-end d-flex pb-4 justify-content-end"
    />
    <add
      v-if="addOpen"
      class="mb-3"
      :collections="dataToCreation"
      @mark-adding="markAdding($event)"
      @on-cancel="
        () => {
          this.addOpen = false;
          this.isAdding = false;
        }
      "
      @on-create="createConfiguration($event)"
    />
    <div v-if="!isAdding">
      <filter-manager
        ref="filterRef"
        v-model="filter.model"
        class="mb-4"
        :filters="filtersConfig"
        @search="searchByCriteria()"
      />

      <custom-separator class="my-4" text="Resultado" />
      <custom-result-not-found
        v-if="results.length == 0"
        text="No cuenta con información disponible."
      />
      <div v-for="row of results" :key="row.id">
        <result-row
          :data="row"
          :determination-types="filter.options.determinationTypes"
          @change-status="onStatusChange"
          @reload="onSearchHandler"
          @remove="removePurchaseRequest"
        />
      </div>
      <pagination
        v-if="showPagination"
        :data="pagination"
        show-text
        @pagination-go-page="goToPageHandler"
      />
    </div>
  </div>
</template>

<script>
//components
import Add from './components/Add.vue';
import FilterManager from 'FilterManager';
import PageHeader from 'PageHeader';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';
import ResultRow from './components/ResultRow.vue';
import storeMixin from '@/shared/mixins/storeGenerator';
import alertMixin from '@/mixins/alert.mixin.js';

//services
import {
  getInitFilters,
  get,
  remove,
  changeStatus,
  getDeterminationCategoryTypes,
} from '@/modules/purchaseService/api.js';
import { getServiceTypesByArea } from '@/modules/serviceProposalHistory/api';
import { serialize as objectToFormData } from 'object-to-formdata';

//constants
const DEFAULT_PAGE_SIZE = 10;
import PurchaseServiceStatus from '@/utils/constants/PurchaseServiceStatus';

export default {
  name: 'Servicepurchaserequest',
  components: {
    Add,
    FilterManager,
    PageHeader,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    ResultRow,
  },
  mixins: [storeMixin, alertMixin],
  data() {
    return {
      headerConfig: {
        title: 'Solicitud Contratación de Servicios',
        icon: 'fas fa-building',
        routes: [
          'Proceso de Competencias',
          'Solicitud Contratación de Servicios',
        ],
      },
      isAdding: false,
      addOpen: false,
      dataToCreation: {
        areas: [],
      },
      filter: {
        model: {
          academicYear: null,
          area: null,
          service: null,
          number: null,
          status: null,
          contractType: null,
          determination: null,
          contactOffice: null,
        },
        options: {
          contractTypes: [],
          areas: [],
          services: [],
          status: [],
          academicYears: [],
          determinationTypes: [],
          contactOffices: [],
        },
      },
      pagination: {
        currentPage: 1,
        totalItemCount: 1,
        pageCount: 1,
        count: 1,
        pageSize: DEFAULT_PAGE_SIZE,
      },
      results: [],
    };
  },
  computed: {
    showPagination() {
      return this.pagination.totalItemCount > this.pagination.pageSize;
    },
    pageHeaderActionsConfig() {
      return [
        {
          text: 'Regresar',
          visible: !this.isAdding,
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => {
            this.$router.push({
              name: 'infraestructure',
            });
          },
        },
        {
          text: 'Añadir',
          visible: !this.addOpen,
          icon: 'fas fa-file-plus',
          variant: 'success',
          click: () => {
            this.addOpen = true;
          },
        },
        {
          text: 'Descargar Guía',
          visible: this.isAdding,
          icon: 'fas fa-arrow-circle-down',
          variant: 'success',
          click: () => {},
        },
      ];
    },
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          class: 'col-md-3',
          options: this.filter.options.academicYears,
          initialValue: this.filter.model.academicYear,
          placeholder: 'Año Fiscal',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
        },
        {
          name: 'contractType',
          component: 'CustomDropDown',
          class: 'col-md-3',
          options: this.filter.options.contractTypes,
          initialValue: this.filter.model.contractType,
          placeholder: 'Tipo de Contratación',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          class: 'col-md-3',
          options: this.filter.options.status,
          initialValue: this.filter.model.status,
          placeholder: 'Estatus',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
        },
        {
          name: 'numberName',
          component: 'CustomInput',
          class: 'col-md-3',
          placeholder: 'Número o Nombre de Solicitud',
          clearable: true,
          icon: 'fas fa-search color-primary-2',
          leftIcon: true,
        },
        {
          name: 'area',
          component: 'CustomDropDown',
          class: 'col-md-3',
          options: this.filter.options.areas,
          initialValue: this.filter.model.area,
          placeholder: 'Seleccione',
          label: 'Área:',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          onChanged: this.onAreaChange,
          clearModelsOnUpdate: ['service'],
          isAdvanced: true,
          disabled: this.filter.options.areas?.length === 1,
        },
        {
          name: 'service',
          component: 'CustomDropDown',
          class: 'col-md-3',
          options: this.filter.options.services,
          initialValue: this.filter.model.service,
          placeholder: 'Seleccione',
          label: 'Servicio a Ofrecer:',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          disabled: this.filter.options.services?.length === 1,
        },
        {
          name: 'determination',
          component: 'CustomDropDown',
          class: 'col-md-3',
          options: this.filter.options.determinationTypes,
          initialValue: this.filter.model.determination,
          placeholder: 'Seleccione',
          label: 'Determinación:',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          disabled: this.filter.options.determinationTypes?.length === 1,
        },
        {
          name: 'contactOffice',
          component: 'CustomDropDown',
          class: 'col-md-3',
          options: this.filter.options.contactOffices,
          initialValue: this.filter.model.contactOffice,
          placeholder: 'Seleccione',
          label: 'Oficina:',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          disabled: this.filter.options.contactOffices?.length === 1,
        },
      ];
    },
  },
  async mounted() {
    await this.fetchInitFilters();
    await Promise.all([this.getDeterminationCategoryTypes()]);
  },
  destroyed() {
    this.persistData();
  },
  beforeRouteEnter(_, from, next) {
    const persistRoutes = ['purchaseServiceDetail', 'BidDocumentationEdit'];
    next(async (vm) => {
      if (persistRoutes.some((x) => x == from.name)) {
        vm.shouldRecovery = false;
        vm.onSearchHandler();
      } else {
        vm.recoveryData();
      }
    });
  },
  methods: {
    async getDeterminationCategoryTypes() {
      const { data } = await getDeterminationCategoryTypes();
      this.filter.options.determinationTypes = data;
    },
    markAdding(value) {
      this.isAdding = value;
    },
    async fetchInitFilters() {
      const { data } = await getInitFilters(false);

      this.filter.options = {
        ...this.filter.options,
        ...data,
        services: [],
      };
      if (this.filter.options.areas?.length === 1) {
        this.filter.model.area = this.filter.options.areas[0];
        await this.onAreaChange(this.filter.model.area);
      }
      if (this.filter.options.contactOffices.length === 1) {
        this.filter.model.contactOffice =
          this.filter.options.contactOffices[0] || null;
      }

      this.dataToCreation.areas = data.areas;
      this.dataToCreation.contractTypes = data.contractTypes;
    },
    async onSearchHandler() {
      const payload = {
        numberName: this.filter.model.numberName,
        academicYearId: this.filter.model.academicYear?.id,
        areaId: this.filter.model.area?.id,
        determinationId: this.filter.model.determination?.id,
        contractTypeId: this.filter.model.contractType?.id,
        contactOfficeId: this.filter.model.contactOffice?.id,
        serviceId: this.filter.model.service?.id,
        statusId: this.filter.model.status?.id,
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      const { data: results = { data: [] } } = await get(payload);
      this.results = results.data.map((x) => ({ ...x, opened: false }));

      this.pagination = {
        ...this.pagination,
        totalItemCount: results.totalItemCount,
        pageCount: results.pageCount,
        currentPage: results.currentPage,
        count: results.count,
      };
    },
    async goToPageHandler(page) {
      this.pagination.currentPage = page;
      await this.onSearchHandler();
    },
    async searchByCriteria() {
      this.pagination.currentPage = 1;
      await this.onSearchHandler();
    },
    async removePurchaseRequest(id) {
      try {
        await remove(id);
        await this.onSearchHandler();
      } catch (error) {
        this.ShowToast(
          '',
          'No se pudo eliminar la solicitud. Intente nuevamente o contacte al administrador.',
          'error'
        );
      }
    },
    async onAreaChange(area) {
      this.filter.options.services = [];
      this.filter.model.service = null;
      if (!area) return;

      const { data } = await getServiceTypesByArea(area.id);
      this.filter.options.services = data;
      if (data?.length === 1) {
        this.filter.model.service = data[0];
      }
    },
    async onStatusChange(id, data, callback) {
      let message = '';
      switch (data.statusId) {
        case PurchaseServiceStatus.UnderReview:
          message =
            '¿Está seguro que desea poner esta solicitud en revisión? El solicitante ya no podrá editarla hasta que finalice el proceso.';
          break;
        case PurchaseServiceStatus.Approved:
          message = '¿Está seguro que desea aprobar esta solicitud?';
          break;
        case PurchaseServiceStatus.Returned:
          message =
            '¿Está seguro que desea devolver esta solicitud al solicitante?';
          break;
        case PurchaseServiceStatus.Rejected:
          message =
            '¿Está seguro que desea rechazar esta solicitud? Una vez rechazada, el solicitante no podrá editar ni reenviar.';
          break;
        case PurchaseServiceStatus.Determined:
          message = '¿Está seguro que desea determinar esta solicitud?';
          break;
        case PurchaseServiceStatus.Signed:
          message = '¿Está seguro que desea cambiar a firmado la solicitud?';
          break;
      }

      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        message,
        'Si',
        'No'
      );

      if (!confirmed) return;

      try {
        const payload = objectToFormData(data, {
          indices: true,
          nullsAsUndefineds: true,
        });
        await changeStatus(id, payload);
        if (callback) await callback();
        await this.onSearchHandler();
      } catch {
        let errorMsg = '';
        switch (data.statusId) {
          case PurchaseServiceStatus.UnderReview:
            errorMsg = 'pasar a revisión';
            break;
          case PurchaseServiceStatus.Approved:
            errorMsg = 'aprobar';
            break;
          case PurchaseServiceStatus.Returned:
            errorMsg = 'devoler';
            break;
          case PurchaseServiceStatus.Rejected:
            errorMsg = 'rechazar';
            break;
          case PurchaseServiceStatus.Determined:
            errorMsg = 'determinar ';
            break;
          case PurchaseServiceStatus.Signed:
            errorMsg = 'firmar ';
            break;
        }
        this.ShowToast(
          '',
          `No se pudo ${errorMsg} la solicitud. Intente nuevamente o contacte al administrador.`,
          'error'
        );
      }
    },
  },
};
</script>
<style scoped>
::v-deep .orange-icon {
  font-size: 18pt;
}
</style>
